export default class ClientsidePaging {
    pageNumber = 1;
    pageSize = 10;
    pageSizeOptions = [10, 20, 50, 100];
}